"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BrandedAppChangelogComponent = /*#__PURE__*/function () {
  BrandedAppChangelogComponent.$inject = ["appBrandingService"];
  /* @ngInject */
  function BrandedAppChangelogComponent(appBrandingService) {
    _classCallCheck(this, BrandedAppChangelogComponent);
    this.appBrandingService = appBrandingService;
  }
  return _createClass(BrandedAppChangelogComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      return this.appBrandingService.getChangelog(this.brandingId).then(function (_ref) {
        var data = _ref.data;
        return _this.changelog = _.map(data, _this.formatLog);
      }, function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "formatLog",
    value: function formatLog(log) {
      log.icon = function () {
        switch (log.type) {
          case 'publishing-request-created':
            return 'icon-shop';
          case 'build-started':
            return 'icon-flash';
          case 'build-finished':
            return 'icon-check';
          case 'store-status':
            switch (log.status) {
              case 'in-review':
                return 'icon-hour-glass';
              case 'rejected':
                return 'icon-warning';
              case 'pending-release':
                return 'icon-thumbs-up';
              case 'published':
                return 'icon-check';
              default:
                return 'icon-shop';
            }
          default:
            return 'icon-new';
        }
      }();
      log.blurb = log.type;
      if (log.status) {
        log.blurb += ": ".concat(log.status);
      }
      if (log.type === 'created') {
        log.blurb += " by ".concat(log.fp_owner.split(':')[1]);
      }
      if (log.type === 'build-finished') {
        log.platform = function () {
          switch (log.platform) {
            case 'ios':
              return 'iOS';
            case 'android':
              return 'Android';
          }
        }();
        log.blurb += " of ".concat(log.build_type, " ").concat(log.platform, " app");
      }
      return _.pick(log, '_id', 'icon', 'blurb', 'created_at');
    }
  }]);
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-changelog', []).component('brandedAppChangelog', {
  templateUrl: '/src/angular/components/branded-app/branded-app-changelog/branded-app-changelog.html',
  bindings: {
    brandingId: '<'
  },
  controller: BrandedAppChangelogComponent
}).name;